export default {
  methods: {
    resetSearchState() {
      this.loading = true;
      this.skip = 0;
      this.allPortsWereLoaded = false;
      this.noPortsAvailable = false;
    },

    buildBaseQuery(query) {
      return {
        zip_code: this.deliveryValue.zip_code,
        city: this.deliveryValue.city,
        miles: this.miles,
        skip: this.skip,
        limit: this.limit,
        ...(query ? { q: query } : {}),
      };
    },

    async fetchPorts(query) {
      const response = await this.$store.dispatch("drayage/getPortsList", query);
      return response?.data?.data ?? [];
    },

    shouldFetchStopPort(ports) {
      return this.isPortStop && this.stopInformation?.name &&
         !ports.some((p) => p.name === this.stopInformation.name);
    },

    async addStopPortIfMissing(ports) {
      const nameQuery = this.buildBaseQuery(this.stopInformation.name);
      const { data } = await this.$store.dispatch("drayage/getPortsList", nameQuery);
      const portsByName = data.data || [];

      const ids = new Set(ports.map((p) => p.id));
      const uniquePortsByName = portsByName.filter((p) => !ids.has(p.id));

      return [...uniquePortsByName, ...ports];
    },

    handlePagination(ports) {
      if (ports.length < this.limit) this.allPortsWereLoaded = true;
    },

    shouldMarkNoPorts(ports, isLoadingMoreData) {
      if (!ports.length && !isLoadingMoreData) {
        this.noPortsAvailable = true;
        this.filteredStops[0].options = [];
        this.stopData = null;
        this.loading = false;
        return true;
      }
      return false;
    },

    updatePortsList(ports, isLoadingMoreData) {
      const newPorts = this.buildStopSelectorZipCodes(ports, true);

      if (!isLoadingMoreData) {
        this.originalPortsList = this.removeDuplicatesById(newPorts);
        this.filteredStops[0].options = this.originalPortsList;
      } else {
        const combined = [...this.originalPortsList, ...newPorts];
        const deduped = this.removeDuplicatesById(combined);

        this.originalPortsList = deduped;
        this.filteredStops[0].options = deduped;
      }
    },

    removeDuplicatesById(ports) {
      const seen = new Set();
      return ports.filter((p) => {
        if (seen.has(p.id)) return false;
        seen.add(p.id);
        return true;
      });
    }

  },
};
